import { createAction } from '@reduxjs/toolkit'

/** Перечитать состояние служб поиска. Команда — plain action, исполняет listener через порт (F05). */
export const searchHealthRequested = createAction('platform/search/healthRequested')
